import { render, staticRenderFns } from "./SummaryCupoQuota.vue?vue&type=template&id=34aaf948&"
import script from "./SummaryCupoQuota.vue?vue&type=script&lang=js&"
export * from "./SummaryCupoQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports